(function () {
	// Delegated so handlers survive AJAX re-renders and late script injection.
	document.addEventListener("click", function (event) {
		const noSubmit = event.target.closest(".no_submit");
		if (noSubmit && document.documentElement.classList.contains("js")) {
			event.preventDefault();
		}

		const toggler = event.target.closest(
			".open_filters, .facets-menu__close, .facets__submit, .facets__reset, .form-menu__mask"
		);
		if (!toggler) return;

		const menuWrapper = document.getElementById("open_filters_menu");
		if (menuWrapper) menuWrapper.classList.toggle("show_menu");
		document.body.classList.toggle("overflow-hidden");
		document.body.classList.toggle("open-filters");
		document
			.querySelectorAll(".shopify-section-header, .section-announcement")
			.forEach(function (el) {
				el.classList.toggle("low_index");
			});
	});

	class SortMenu extends HTMLElement {
		constructor() {
			super();
			this.select = this.querySelector("select");
			this.button = this.querySelector(".sort-menu__button");
			this.list = this.querySelector(".sort-menu__list");
			this.options = Array.from(this.querySelectorAll(".sort-menu__option"));
			if (!this.select || !this.button || !this.list) return;

			// hide the native select + its arrow, reveal the custom control
			this.classList.add("sort-menu--enhanced");
			this.button.hidden = false;

			this.button.addEventListener("click", this.toggle.bind(this));
			this.button.addEventListener("keydown", (event) => {
				if (event.key === "ArrowDown" || event.key === "ArrowUp") {
					event.preventDefault();
					this.open();
					this.focusOption(this.selectedIndex());
				}
			});

			this.options.forEach((option, index) => {
				option.addEventListener("click", () => this.choose(option));
				option.addEventListener("keydown", (event) => {
					if (event.key === "ArrowDown") {
						event.preventDefault();
						this.focusOption(index + 1);
					} else if (event.key === "ArrowUp") {
						event.preventDefault();
						this.focusOption(index - 1);
					} else if (event.key === "Home") {
						event.preventDefault();
						this.focusOption(0);
					} else if (event.key === "End") {
						event.preventDefault();
						this.focusOption(this.options.length - 1);
					}
				});
			});

			this.addEventListener("keydown", (event) => {
				if (event.key === "Escape") {
					this.close();
					this.button.focus();
				}
			});
			this.addEventListener("focusout", (event) => {
				if (!this.contains(event.relatedTarget)) this.close();
			});
			document.addEventListener("click", (event) => {
				if (!this.contains(event.target)) this.close();
			});
		}

		selectedIndex() {
			const index = this.options.findIndex(
				(option) => option.getAttribute("aria-selected") === "true"
			);
			return index < 0 ? 0 : index;
		}

		focusOption(index) {
			const clamped = Math.max(0, Math.min(this.options.length - 1, index));
			this.options[clamped].focus();
		}

		toggle() {
			if (this.classList.contains("sort-menu--open")) {
				this.close();
			} else {
				this.open();
			}
		}

		open() {
			this.classList.add("sort-menu--open");
			this.button.setAttribute("aria-expanded", "true");
		}

		close() {
			this.classList.remove("sort-menu--open");
			this.button.setAttribute("aria-expanded", "false");
		}

		choose(option) {
			const value = option.dataset.value;
			if (this.select.value !== value) {
				this.select.value = value;
				this.select.dispatchEvent(new Event("input", { bubbles: true }));
			}
			this.options.forEach((other) =>
				other.setAttribute("aria-selected", other === option ? "true" : "false")
			);
			const current = this.button.querySelector(".sort-menu__current");
			if (current) current.textContent = option.textContent.trim();
			this.close();
			this.button.focus();
		}
	}

	if (!customElements.get("sort-menu")) {
		customElements.define("sort-menu", SortMenu);
	}
})();
